export default {
    translations: {
        notification: 'Benachrichtigung',
        you: 'Sie',
        ok: 'OK',
        yes: 'Ja',
        no: 'Nein',
        userType: {
            translator: 'Dolmetscher:in',
            translators: 'Dolmetcher:innen',
            attendee: 'Teilnehmer:in',
            attendees: 'Teilnehmer:innen',
            moderator: 'Organisator:in',
            moderators: 'Organisator:innen',
        },
        notifications: {
            userJoined: '{{name}} ist der Sitzung beigetreten',
            userLeft: '{{name}} hat die Sitzung verlassen',
            userWaiting: '{{name}} möchte an Ihrer Sitzung teilnehmen',
        },
        chat: {
            headline: 'Nachrichten',
            encryptionFailed: 'Entschlüsselung fehlgeschlagen',
            header: '{{names}} und Sie',
            noOtherUsers: 'Noch keine Gesprächspartner',
            newMessage: 'Neue Nachricht',
            sendMessage: 'Nachricht senden',
            uploadFile: 'Datei hochladen',
            typing_one: '<i>{{name}}</i> tippt gerade',
            typing_other: '<i>{{names}}</i> und <i>{{name}}</i> tippen gerade',
            waitToEnter: 'Sie können an der Sitzung teilnehmen, sobald Sie von Ihrem Host zugelassen werden.',
            removed: {
                title: 'Aus der Sitzung entfernt',
                message: 'Der Host hat Sie aus dieser Sitzung entfernt. Dieser Link ist nicht mehr gültig.',
            },
            sessionEnded: {
                title: 'Sitzung beendet',
                message: 'Der Host hat die Sitzung für alle beendet.',
            },
            sessionExpired: {
                title: 'Sitzung abgelaufen',
                message: 'Ihre Sitzung ist abgelaufen und konnte nicht verlängert werden. Bitte treten Sie der Sitzung erneut bei.',
                joinMessage: 'Diese Sitzung ist nicht mehr gültig. Bitte fordern Sie einen neuen Einladungslink an.',
            },
            sessionFailed: {
                title: 'Etwas ist schiefgelaufen',
                message: 'Ein Fehler hat die Sitzung unterbrochen, und Sie haben sie verlassen. Bitte treten Sie der Sitzung erneut bei.',
            },
            noSessionHere: {
                title: 'In diesem Tab ist keine Sitzung geöffnet',
                message: 'Öffnen Sie Ihren Beitrittslink erneut oder treten Sie mit Videodolmetsch-ID und -Passwort bei.',
            },
            removedNotice: '<strong>{{name}}</strong> wurde vom Host aus der Sitzung entfernt.',
            joinFailed: 'Beitritt fehlgeschlagen. Bitte versuchen Sie es erneut.',
            publishFailed: 'Ihre Kamera und Ihr Mikrofon konnten nicht übertragen werden. Die anderen Teilnehmer:innen können Sie weder sehen noch hören.',
            publishFailedCamera: 'Ihre Kamera konnte nicht übertragen werden. Die anderen Teilnehmer:innen können Sie nicht sehen.',
            publishFailedMicrophone: 'Ihr Mikrofon konnte nicht übertragen werden. Die anderen Teilnehmer:innen können Sie nicht hören.',
            receiveFailed: 'Kamera und Mikrofon der anderen Teilnehmer:innen konnten nicht empfangen werden.',
            sendFailed: 'Ihre Nachricht konnte nicht gesendet werden.',
            notReadableHere: 'In diesem Browser nicht lesbar',
            notReadableHereNote: 'Frühere Nachrichten wurden für den Browser verschlüsselt, mit dem Sie zuvor teilgenommen haben. Hier können sie nicht entschlüsselt werden.',
            endSessionFailed: 'Die Sitzung konnte nicht beendet werden. Für die anderen Teilnehmer:innen läuft sie weiter.',
            prefsSaveFailed: 'Ihre Spracheinstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
            prefsSaveFailedJoin: 'Ihre Spracheinstellungen konnten nicht gespeichert werden. Sie können sie jederzeit unter "Einstellungen > Dolmetscher:in" ändern.',
            leaveSession: 'Sitzung verlassen',
            endSession: 'Sitzung beenden',
            confirm: {
                closeChat: {
                    title: 'Videodolmetschsitzung beenden',
                    message: 'Möchten Sie die Videodolmetschsitzung wirklich beenden?',
                },
                leaveSession: {
                    title: 'Sitzung verlassen',
                    message: 'Möchten Sie die Sitzung verlassen? Sie können später mit demselben Link erneut beitreten.',
                },
            },
        },
        sidebar: {
            participants: {
                title: 'Personen',
                admit: 'Zulassen',
                admitFailed: 'Die Person konnte nicht zugelassen werden. Bitte versuchen Sie es erneut.',
                remove: 'Entfernen',
                removeFailed: 'Die Person konnte nicht entfernt werden. Bitte versuchen Sie es erneut.',
                confirmRemove: {
                    title: 'Aus der Sitzung entfernen',
                    message: 'Sind Sie sicher, dass Sie diese Person entfernen möchten? Nach der Entfernung wird sie von der Teilnehmer:innenliste gestrichen und kann an dieser Sitzung nicht mehr teilnehmen.',
                },
                status: {
                    admitted: 'Bereits beigetreten',
                    waiting: 'Noch nicht beigetreten',
                    invited: 'Eingeladen',
                }
            },
            chat: {
                title: 'Nachrichten',
            },
            settings: {
                title: 'Einstellungen',
                video: 'Video',
                audio: 'Audio',
                interpreter: 'Dolmetscher:in',
                save: 'Speichern',
                saving: 'Wird gespeichert...',
                reset: 'Zurücksetzen',
                rowAudio: {
                    title: 'Audio',
                },
                rowVideo: {
                    title: 'Video',
                },
            }
        },
        participants: {
            headline: 'Teilnehmer:innen',
            active: 'Aktiv',
            inactive: 'Inaktiv',
            admin: "Organisator:in"
        },
        signature: {
            requestSignature: 'Signatur beantragen',
        },
        videoControl: {
            enter: 'Beitreten',
            accept: 'Annehmen',
            decline: 'Ablehnen',
            hangUp: 'Auflegen',
            exit: 'Beenden',
            screenShare: {
                enable: 'Bildschirm freigeben',
                disable: 'Bildschirmfreigabe beenden'
            },
            camera: {
                enable: 'Kamera einschalten',
                disable: 'Kamera ausschalten'
            },
            mic: {
                enable: 'Mikrofon einschalten',
                disable: 'Mikrofon ausschalten'
            },
            pushToTalk: 'Eine Durchsage machen (bitte halten Sie die Taste während der Durchsage gedrückt)',
            participants: 'Teilnehmer:innen',
            messages: 'Nachrichten',
            settings: 'Einstellungen',
            chat: {
                show: 'Chat anzeigen',
                hide: 'Chat verbergen'
            }
        },
        videoGrid: {
            tileFailed: 'Bild und Ton nicht verfügbar',
            ownTileFailed: 'Vorschau nicht verfügbar',
        },
        pageFailed: {
            message: 'Ein Fehler hat die Seite angehalten. Laden Sie sie neu, um der Sitzung erneut beizutreten.',
            reload: 'Neu laden',
        },
        conferenceWaiting: {
            title: 'Gleich geht es los',
            message: 'Sie können der Konferenz nun beitreten. Klicken Sie auf die Schaltfläche unten, um den Konferenzraum zu betreten.',
            yourTranslators: 'Ihre zugewiesenen Dolmetscher:innen',
            noTranslators: 'Für Ihre Sprachkombination wurden keine Dolmetscher:innen gefunden.',
            audibleUsers: 'Nutzer, die Sie hören werden',
            noAudibleUsers: 'Noch keine Teilnehmer:innen gefunden. Die Liste wird automatisch aktualisiert.',
            continue: 'Weiter zur Konferenz',
        },
        conferenceInfo: {
            title: 'Konferenz-Informationen',
            languages: 'Sprachen',
            neededLanguages: 'Wählen Sie die Sprache(n) aus, für die Sie eine:n Dolmetscher:in benötigen',
            spokenLanguage: 'Wählen Sie Ihre gesprochene Sprache aus',
            simultanConfig: 'Wählen Sie Ihre Einstellung für Simultandolmetschen aus',
            simultanReduce: 'Ich möchte die Lautstärke des:der Sprecher:in reduzieren.',
            simultanMute: 'Ich möchte die Lautstärke des:der Sprecher:in stummschalten.',
            selectPlaceholder: 'Auswählen',
            continue: 'Weiter zur Konferenz',
            preferencesSet: 'Ihre Spracheinstellungen wurden bereits gespeichert.',
            yourParticipants: 'Ihnen zugewiesene Teilnehmer:innen',
            noParticipantsYet: 'Noch keine Teilnehmer:innen zugewiesen. Die Liste wird automatisch aktualisiert.',
            summary: {
                spoken: 'Sprache, die Sie sprechen',
                needInterpretation: 'Sprachen, für die Sie Übersetzung benötigen',
                understood: 'Sprachen, die Sie verstehen',
            },
        },
        lobby: {
            button: {
                video: {
                    enable: 'Kamera einschalten',
                    disable: 'Kamera ausschalten',
                },
                microphone: {
                    enable: 'Mikrofon einschalten',
                    disable: 'Mikrofon ausschalten',
                },
                settings: 'Einstellungen',
            },
            loading: 'Laden',
            camera: 'Kamera',
            noCamera: 'Keine Kamera',
            cameraOff: 'Kamera ausgeschaltet',
            cameraStarting: 'Kamera wird gestartet…',
            simultanConfigInfo: 'Beim Simultandolmetschen sprechen Teilnehmende und Dolmetschende nahezu gleichzeitig. Damit Sie die Dolmetschung gut hören, wird die sprechende Person automatisch leiser gestellt.\n\nSie haben zwei Optionen:\n\n1) Reduzierte Lautstärke: Sie hören die Dolmetschung normal und die sprechende Person leiser im Hintergrund.\n\n2) Stummgeschaltet: Sie hören nur die Dolmetschung.\n\nDiese Einstellung können Sie jederzeit unter „Einstellungen > Dolmetscher:in" ändern.',
            spokenLanguageInfo: 'Ist Ihre Sprache nicht dabei? Kontaktieren Sie bitte den:die Organisator:in dieser Videodolmetschsitzung. Sie können trotzdem beitreten und die Sprache jederzeit unter „Einstellungen > Dolmetscher:in" ändern.',
            cameraDenied: 'Der Zugriff auf Ihre Kamera wurde von Ihrem Browser blockiert. Bitte erlauben Sie den Kamerazugriff in Ihren Browsereinstellungen.',
            cameraDeniedSystem: 'Der Zugriff auf Ihre Kamera wurde von Ihrem Betriebssystem blockiert. Bitte erlauben Sie den Kamerazugriff in den Systemeinstellungen.',
            cameraUnavailable: 'Ihre Kamera konnte nicht gestartet werden. Möglicherweise wird sie von einem anderen Programm verwendet.',
            cameraNotFound: 'Es wurde keine Kamera gefunden. Bitte schließen Sie eine Kamera an oder prüfen Sie, ob sie in Ihren Systemeinstellungen deaktiviert ist.',
            cameraLost: 'Ihre Kamera wird wiederholt getrennt. Bitte prüfen Sie die Verbindung oder wählen Sie eine andere Kamera und versuchen Sie es erneut.',
            microphoneDenied: 'Der Zugriff auf Ihr Mikrofon wurde von Ihrem Browser blockiert. Bitte erlauben Sie den Mikrofonzugriff in Ihren Browsereinstellungen.',
            microphoneDeniedSystem: 'Der Zugriff auf Ihr Mikrofon wurde von Ihrem Betriebssystem blockiert. Bitte erlauben Sie den Mikrofonzugriff in den Systemeinstellungen.',
            microphoneUnavailable: 'Ihr Mikrofon konnte nicht gestartet werden. Möglicherweise wird es von einem anderen Programm verwendet.',
            microphoneNotFound: 'Es wurde kein Mikrofon gefunden. Bitte schließen Sie ein Mikrofon an oder prüfen Sie, ob es in Ihren Systemeinstellungen deaktiviert ist.',
            microphoneLost: 'Ihr Mikrofon wird wiederholt getrennt. Bitte prüfen Sie die Verbindung oder wählen Sie ein anderes Mikrofon und versuchen Sie es erneut.',
            microphoneMutedSystem: 'Ihr Mikrofon wurde von Ihrem Betriebssystem stummgeschaltet und andere Teilnehmer:innen können Sie nicht hören. Bitte heben Sie die Stummschaltung über die Mikrofontaste Ihres Geräts oder in den Systemeinstellungen auf.',
            retry: 'Erneut versuchen',
            deviceListFailed: 'Ihre Geräte konnten nicht gelesen werden. Die Auswahl von Kamera, Mikrofon und Lautsprecher ist möglicherweise unvollständig.',
            none: 'Keine',
            systemDefault: 'Standard',
            cameraFallback: 'Ihre zuvor ausgewählte Kamera ist nicht verfügbar. Es wird "{{name}}" verwendet.',
            microphoneFallback: 'Ihr zuvor ausgewähltes Mikrofon ist nicht verfügbar. Es wird "{{name}}" verwendet.',
            speakerFallback: 'Ihr zuvor ausgewählter Lautsprecher ist nicht verfügbar. Es wird "{{name}}" verwendet.',
            speakerUnavailable: 'Der ausgewählte Lautsprecher konnte nicht verwendet werden. Die Wiedergabe läuft weiter über das Standardgerät Ihres Systems.',
            speakerBlocked: 'Ihr Browser erlaubt keine Auswahl des Wiedergabegeräts. Die Wiedergabe läuft über das Standardgerät Ihres Systems – bitte ändern Sie es in den Systemeinstellungen.',
            speakerTest: 'Testen',
            speakerTesting: 'Testton läuft…',
            speakerTestPlayed: 'Ein Testton wurde über "{{name}}" abgespielt. Wenn Sie nichts gehört haben, prüfen Sie die Lautstärke und die Stummschaltung Ihres Geräts. Oder wählen Sie unten einen anderen Lautsprecher.',
            speakerTestFailed: 'Der Testton konnte nicht abgespielt werden.',
            speakerNotFound: 'Es wurde kein Wiedergabegerät gefunden. Bitte schließen Sie einen Lautsprecher oder Kopfhörer an oder prüfen Sie, ob das Gerät in Ihren Systemeinstellungen deaktiviert ist.',
            microphone: 'Mikrofon',
            microphoneLevel: 'Mikrofon-Eingangspegel',
            microphoneTest: 'Testen',
            microphoneTestRecording: 'Aufnahme läuft…',
            microphoneTestPlaying: 'Wiedergabe läuft…',
            microphoneTestStop: 'Beenden',
            microphoneTestMuteHint: 'Während des Tests hören die anderen Teilnehmer:innen Sie nicht',
            microphoneTestStarted: 'Die Aufnahme läuft. Während des Tests hören die anderen Teilnehmer:innen Sie nicht.',
            microphoneTestPlayed: 'Ihre Aufnahme wurde über "{{name}}" abgespielt. Sie bleibt in Ihrem Browser und wird weder gespeichert noch übertragen.',
            microphoneTestPlayedLive: 'Ihre Aufnahme wurde über "{{name}}" abgespielt. Sie bleibt in Ihrem Browser und wird weder gespeichert noch übertragen. Während des Tests hören die anderen Teilnehmer:innen Sie nicht.',
            microphoneTestFailed: 'Die Aufnahme konnte nicht abgespielt werden.',
            microphoneTestMuted: 'Ihr Mikrofon ist ausgeschaltet. Schalten Sie es ein, um eine Aufnahme zu testen.',
            microphoneTestMutedSystem: 'Ihr Mikrofon ist in den Systemeinstellungen stummgeschaltet. Schalten Sie es ein, um eine Aufnahme zu testen.',
            speaker: 'Lautsprecher',
            speakerLevel: 'Lautsprecher-Ausgabepegel',
            background: 'Hintergrund',
            backgroundOptions: {
                none: 'Keine Änderung',
                blur: 'Weichzeichen',
                hide: 'Ausblenden',
            },
            yourName: 'Ihre Informationen',
            nameLabel: 'Geben Sie Ihren Namen ein',
            enterNow: 'Jetzt beitreten',
            leave: 'Verlassen',
            noPermission: 'Keine Berechtigung',
            agb: {
                prefix: 'Mit Ihrem Beitritt stimmen Sie unseren',
                terms: 'AGB',
                conjunction: 'und',
                privacy: 'Datenschutzbestimmungen',
                suffix: 'zu.',
            },
        }
    }
}
